module.exports = __webpack_public_path__ + "img/PR3-B.5655002f.png";